import { Price } from '../../utils/price';
export function totalPriceAfterPromocodeApplied(price, promocode) {
  if (!promocode || !promocode.discount || !promocode.measurement) {
    return price;
  }
  return Price.applyDiscount(price, promocode.discount, promocode.measurement);
}